export function formatLoanProduct(product: string | null | undefined) {
  if (!product) {
    return null;
  }

  switch (product.toLowerCase()) {
    case "conventional":
    case "conventional_30":
      return "Conventional loan";
    case "arm_7_6":
      return "7/6 ARM";
    case "fha":
    case "fha_30":
      return "FHA loan";
    case "va":
    case "va_30":
      return "VA loan";
    default:
      return product
        .replace(/_/g, " ")
        .replace(/\b\w/g, (letter) => letter.toUpperCase());
  }
}
